import data from "../../shared/sharedData";

export default {
  name: "Employment and Wage Information",
  pageInfo: {
    text: "The employer must define the intended place(s) of employment with as much geographic specificity as possible. Each intended place(s) of employer listed below <u> must be the worksite or physical location where the work will actually be performed and cannot be a P.O. box</u>. The employer <u>must</u> identify all intended places of employment, including those of short duration, on the LCA. 20 CFR655.730(c)(5).",
    coloring: "grey",
  },
  prefix: "F",
  sections: [
    {
      divider: "hide",
      fields: [
        {
          code: "F FieldArray",
          label: "F",
          machine_name: "section_f",
          validate: [
            "tableRequired",
            {
              fieldArraySumLessThan: "b7_total_positions",
              needsFieldValues: true,
              extraData: {
                fieldArray: "section_f",
                fieldToCheck: "f1_number_workers",
              },
              message:
                "The total amount of workers (specified in F1) in this section must be equal to or greater than the total you specified in B7.",
            },
            {
              fieldArrayContainsOldIndex: data.wageDateSeries,
              needsFieldValues: true,
              extraData: {
                fieldArray: "section_f",
                fieldToCheck: "f13b_source_year",
              },
              message:
                "One or more Entries for Place of Employment contain wage data from the previous Series and Source Year. Please update each entry to use the latest wage data.",
            },
          ],
          hidden: true,
        },
      ],
    },
    {
      code: "F",
      machine_name: "section_f",
      isFieldArray: true,
      fieldArray: {
        limit: 10,
        limit_message: "You may only enter 10 additional places of employment",
        count_label: "Entries for Place of Employment",
        noun: "Place of Employment",
        info: "Use the fields above to enter the details of each additional place of employment, when applicable",
        table: {
          headers: ["Total Worker(s)", "Address", "Wage Rate"],
          value_machine_names: [
            "f1_number_workers",
            "f4_work_address_1",
            {
              template: `wage_rate`,
              machine_names: [
                "f10_nonimmigrant_wage_from",
                "f10_nonimmigrant_wage_to",
                "f10a_nonimmigrant_wage_per",
              ],
            },
          ],
        },
        clear_schema: [
          {
            when: "_section_f_f12_f13_f14_prevailing_wage_question",
            is: "f12_is_dol_prevailing_wage",
            clear: [
              "_section_f_f13a_wage_level",
              "_section_f_f13b_source_year",
              "_section_f_f14a_source_type",
              "_section_f_f14b_source_year_cba",
              "_section_f_f14b_source_year_notcba",
              "_section_f_f14c_survey_publisher",
              "_section_f_f14d_survey_name",
            ],
          },
          {
            when: "_section_f_f12_f13_f14_prevailing_wage_question",
            is: "f13_is_oes_prevailing_wage",
            clear: [
              "_section_f_f12a_pwd_number",
              "_section_f_f14a_source_type",
              "_section_f_f14b_source_year_cba",
              "_section_f_f14b_source_year_notcba",
              "_section_f_f14c_survey_publisher",
              "_section_f_f14d_survey_name",
            ],
          },
          {
            when: "_section_f_f12_f13_f14_prevailing_wage_question",
            is: "f14_non_oes_prevailing_wage",
            clear: [
              "_section_f_f12a_pwd_number",
              "_section_f_f13a_wage_level",
              "_section_f_f13b_source_year",
              "_section_f_f14b_source_year",
            ],
          },
          {
            when: "_section_f_f2_is_secondary_entity",
            is: "NO",
            clear: ["_section_f_f3_secondary_entity_name"],
          },
          // {
          //   when: '_section_f_f14a_source_type',
          //   is: 'CBA',
          //   clear: [
          //     '_section_f_f14b_source_year_notcba'
          //   ]
          // },
          // {
          //   when: '_section_f_f14a_source_type',
          //   is: 'DBA',
          //   clear: [
          //     '_section_f_f14b_source_year_cba'
          //   ]
          // },
          // {
          //   when: '_section_f_f14a_source_type',
          //   is: 'SCA',
          //   clear: [
          //     '_section_f_f14b_source_year_cba'
          //   ]
          // },
          // {
          //   when: '_section_f_f14a_source_type',
          //   is: 'Other/PW Survey',
          //   clear: [
          //     '_section_f_f14b_source_year_cba'
          //   ]
          // }
        ],
        required_schema: [
          "_section_f_f12_f13_f14_prevailing_wage_question",
          {
            require: "_section_f_f12a_pwd_number",
            when: "_section_f_f12_f13_f14_prevailing_wage_question",
            is: "f12_is_dol_prevailing_wage",
          },
          {
            require: "_section_f_f13a_wage_level",
            when: "_section_f_f12_f13_f14_prevailing_wage_question",
            is: "f13_is_oes_prevailing_wage",
          },
          {
            require: "_section_f_f13b_source_year",
            when: "_section_f_f12_f13_f14_prevailing_wage_question",
            is: "f13_is_oes_prevailing_wage",
          },
          {
            require: "_section_f_f14a_source_type",
            when: "_section_f_f12_f13_f14_prevailing_wage_question",
            is: "f14_non_oes_prevailing_wage",
          },
          {
            require: "_section_f_f14b_source_year_cba",
            when: "_section_f_f14a_source_type",
            is: "CBA",
          },
          {
            require: "_section_f_f14b_source_year_notcba",
            when: "_section_f_f14a_source_type",
            isNot: "CBA",
          },
          {
            require: "_section_f_f14c_survey_publisher",
            when: "_section_f_f14a_source_type",
            is: "Other/PW Survey",
          },
          {
            require: "_section_f_f14d_survey_name",
            when: "_section_f_f14a_source_type",
            is: "Other/PW Survey",
          },
          "_section_f_f1_number_workers",
          "_section_f_f2_is_secondary_entity",
          {
            require: "_section_f_f3_secondary_entity_name",
            when: "_section_f_f2_is_secondary_entity",
            is: "YES",
          },
          "_section_f_f4_work_address_1",
          "_section_f_f6_work_city",
          "_section_f_f8_work_state_id",
          {
            require: "_section_f_f7_work_county_id",
            when: "_section_f_f2_is_secondary_entity",
          },
          "_section_f_f9_work_zip",
          "_section_f_f10_nonimmigrant_wage_from",
          "_section_f_f10a_nonimmigrant_wage_per",
          "_section_f_f11_prevailing_wage",
          "_section_f_f11a_prevailing_wage_per",
        ],
        page: {
          sections: [
            {
              divider: "hide",
              fields: [
                {
                  isGroup: {
                    //each radio button here is a separate machine name and stored separately
                    //if the user selects the first button, we need to store YES for f12, null for f13 and f14
                    //each of the radio buttons will also trigger a unique conditional field
                    code: "F.12-F.14",
                    machine_name:
                      "_section_f_f12_f13_f14_prevailing_wage_question",
                    label:
                      "Identify the source user for the prevailing wage (PW)",
                    tooltip:
                      "Select the source for the Prevailing Wage for this application",
                    coloring: "none",
                    required: true,
                    fields: [
                      {
                        widget: "radio",
                        choice:
                          "F.12. A Prevailing Wage Determination (PWD) issued by the Department of Labor",
                        value: "f12_is_dol_prevailing_wage",
                      },
                      {
                        widget: "radio",
                        choice:
                          "F.13. A PW obtained independently from the Occupational Employment Statistics (OES) program",
                        value: "f13_is_oes_prevailing_wage",
                        disabled: false,
                      },
                      {
                        widget: "radio",
                        choice:
                          "F.14. A PW obtained using another legitimate source (other than OES) or an independent authoritative source",
                        value: "f14_non_oes_prevailing_wage",
                      },
                    ],
                  },
                },
                {
                  code: "F.12a",
                  machine_name: "_section_f_f12a_pwd_number",
                  widget: "pw_lookup",
                  label: "Prevailing Wage Determination (PWD) tracking number",
                  required: true,
                  maxLength: 18,
                  tooltip: `Enter the NPWC PWD tracking number.`,
                  validate: ["required", "pNumberCheck"],
                  isVisible: {
                    when: "_section_f_f12_f13_f14_prevailing_wage_question",
                    is: "f12_is_dol_prevailing_wage",
                  },
                  pw_lookup: {
                    formType: {
                      this: "9141",
                      to: "9035",
                    },
                    PWFields: {
                      PWLinkingFields: ["_section_f_f12a_pwd_number"],
                    },
                    icertView: true,
                    noPrefill: true,
                    buttonView: "Prevailing Wage Determination Lookup",
                    buttonPrimary: "PWD Case Lookup",
                    socField: "b2_soc_code",
                    feinField: "c12_emp_fein",
                  },
                },
                {
                  isGroup: {
                    showIndividualFieldError: true,
                    isVisible: {
                      when: "_section_f_f12_f13_f14_prevailing_wage_question",
                      is: "f13_is_oes_prevailing_wage",
                    },
                    fields: [
                      {
                        machine_name: "something_fake",
                        widget: "wage_calculator",
                        code: "F.13c",
                      },
                      {
                        isGroup: {
                          code: "F.13a",
                          machine_name: "_section_f_f13a_wage_level",
                          label: "Wage Level",
                          tooltip: `Enter OES wage level for the OES prevailing wage.`,
                          required: true,
                          disabled: true,
                          fields: [
                            {
                              widget: "radio",
                              choice: "I",
                              value: "I",
                              disabled: true,
                            },
                            {
                              widget: "radio",
                              choice: "II",
                              value: "II",
                              disabled: true,
                            },
                            {
                              widget: "radio",
                              choice: "III",
                              value: "III",
                              disabled: true,
                            },
                            {
                              widget: "radio",
                              choice: "IV",
                              value: "IV",
                              disabled: true,
                            },
                            {
                              widget: "radio",
                              choice: "N/A",
                              value: "N/A",
                              disabled: true,
                            },
                          ],
                        },
                      },
                      {
                        code: "F.13b",
                        machine_name: "_section_f_f13b_source_year",
                        label: "Source Year",
                        widget: "select",
                        selection: [data.wageDateSeries], // needs to be updated each year on July 1 when OES wages are updated
                        required: true,
                        disabled: true,
                        validate: ["select_required"],
                        tooltip: `Enter the year of the OES prevailing wage.`,
                      },
                    ],
                  },
                },
                {
                  isGroup: {
                    showIndividualFieldError: true,
                    isVisible: {
                      when: "_section_f_f12_f13_f14_prevailing_wage_question",
                      is: "f14_non_oes_prevailing_wage",
                    },
                    fields: [
                      {
                        isGroup: {
                          showIndividualFieldError: false,
                          code: "F.14a",
                          machine_name: "_section_f_f14a_source_type",
                          label: "Wage Level",
                          tooltip: `Indicate the prevailing wage source type.`,
                          required: true,
                          fields: [
                            {
                              widget: "radio",
                              choice: "CBA",
                              value: "CBA",
                            },
                            {
                              widget: "radio",
                              choice: "DBA",
                              value: "DBA",
                            },
                            {
                              widget: "radio",
                              choice: "SCA",
                              value: "SCA",
                            },
                            {
                              widget: "radio",
                              choice: "Other/PW Survey",
                              value: "Other/PW Survey",
                            },
                          ],
                        },
                      },
                      {
                        code: "F.14b",
                        machine_name: "_section_f_f14b_source_year_notcba",
                        label: "Source Year",
                        widget: "select",
                        yearSelection: ["current", -1, -2],
                        tooltip: `Enter the year of the prevailing wage source. For unpublished surveys issued to or produced for the employer, enter the year.`,
                        required: true,
                        validate: ["select_required"],
                        maxLength: 15,
                        isVisible: {
                          when: "_section_f_f14a_source_type",
                          is: "CBA",
                          operator: "!==",
                        },
                      },
                      {
                        code: "F.14b",
                        machine_name: "_section_f_f14b_source_year_cba",
                        label: "Source Year",
                        widget: "select",
                        yearRange: [1990, "current"],
                        tooltip: `Enter the year of the prevailing wage source. For unpublished surveys issued to or produced for the employer, enter the year.`,
                        required: true,
                        validate: ["select_required"],
                        maxLength: 15,
                        isVisible: {
                          when: "_section_f_f14a_source_type",
                          is: "CBA",
                        },
                      },
                      {
                        code: "F.14c",
                        machine_name: "_section_f_f14c_survey_publisher",
                        label:
                          "Enter the name of the survey producer or publisher",
                        widget: "text",
                        required: true,
                        maxLength: 60,
                        tooltip: `For a prevailing wage survey, enter the survey producer or publisher (e.g., survey company name).`,
                        isVisible: {
                          when: "_section_f_f14a_source_type",
                          is: "Other/PW Survey",
                        },
                      },
                      {
                        code: "F.14d",
                        machine_name: "_section_f_f14d_survey_name",
                        label: "Enter the title or name of the PW survey",
                        widget: "text",
                        required: true,
                        maxLength: 60,
                        tooltip: `For a prevailing wage survey, enter the title or source of the prevailing wage survey (e.g., name of the survey instrument).`,
                        isVisible: {
                          when: "_section_f_f14a_source_type",
                          is: "Other/PW Survey",
                        },
                      },
                    ],
                  },
                },
              ],
            },
            {
              fields: [
                {
                  code: "F.1",
                  machine_name: "_section_f_f1_number_workers",
                  widget: "text",
                  label:
                    "Enter the estimated number of workers that will perform work at this place of employment under the LCA",
                  required: true,
                  validate: [
                    "number",
                    {
                      minValue: 1,
                      message: "Total Workers must be greater than 0.",
                    },
                    {
                      fieldComparison: "_section_f_f1_number_workers",
                      message:
                        "The number of workers at this place of employment may not exceed the total number of workers in B.7",
                      needsFieldValues: true,
                      extraData: {
                        operator: "<=",
                        valueOf: "b7_total_positions",
                      },
                    },
                  ],
                  parse: "positiveWholeNumber",
                  maxLength: 4,
                  tooltip:
                    "From the overall total worker positions entered in Item B.7, enter the estimated number of workers that will perform work at this place of employment.",
                },
                {
                  isGroup: {
                    code: "F.2",
                    machine_name: "_section_f_f2_is_secondary_entity",
                    label:
                      "Indicate whether the worker(s) subject to this LCA will be placed with a secondary entity at this place of employment",
                    tooltip:
                      "For this intended place of employment, indicate whether the employer is placing the nonimmigrant worker(s) with a secondary entity. A secondary entity is another entity at which or with which LCA workers will be placed during the period of certification.",
                    fields: [
                      {
                        widget: "radio",
                        choice: "Yes",
                        value: "YES",
                        required: true,
                      },
                      {
                        widget: "radio",
                        choice: "No",
                        value: "NO",
                        required: true,
                      },
                    ],
                  },
                },
                {
                  code: "F.3",
                  machine_name: "_section_f_f3_secondary_entity_name",
                  widget: "textarea",
                  label: "Legal Business name of secondary entity",
                  validate: [
                    {
                      minLength: 5,
                      message:
                        "Legal Business Name of secondary entity must contain at least 5 characters",
                    },
                  ],
                  required: true,
                  isVisible: {
                    when: "_section_f_f2_is_secondary_entity",
                    is: "YES",
                  },
                  warning: {
                    text: "Please enter a valid Legal Business Name.",
                    isVisible: {
                      when: "_section_f_f3_secondary_entity_name",
                      is: [
                        "$",
                        "%",
                        "*",
                        "+",
                        "=",
                        "?",
                        "@",
                        "^",
                        "_",
                        "{",
                        "|",
                        "}",
                        "~",
                        "<",
                        ">",
                      ],
                      operator: "includesCharacters",
                    },
                  },
                  maxLength: 120,
                  tooltip:
                    "If “Yes” to Item F.2, provide the legal business name of the secondary entity (e.g., another entity) at which or with which the nonimmigrant worker(s) will be placed. <br/>Note: The entry must include the legal business name of the secondary entity. Any trade name or DBA name should also be entered, as space permits.",
                },
              ],
            },
            {
              fields: [
                {
                  code: "F.4",
                  machine_name: "_section_f_f4_work_address_1",
                  widget: "text",
                  label: "Address 1",
                  required: true,
                  validate: [
                    // "required",
                    {
                      minLength: 5,
                      message: "Address 1 must contain at least 5 characters.",
                    },
                  ],
                  maxLength: 60,
                  tooltip:
                    "Enter the street address of the intended place of employment.",
                },
                {
                  code: "F.5",
                  machine_name: "_section_f_f5_work_address_2",
                  widget: "text",
                  label:
                    "<span>Address 2 <i>(apartment/suite/floor and number)</i></span>",
                  maxLength: 60,
                  tooltip: `If additional space is needed for the street address, use this line.`,
                },
                {
                  code: "F.6",
                  machine_name: "_section_f_f6_work_city",
                  widget: "text",
                  label: "City",
                  required: true,
                  validate: [
                    // "required",
                    {
                      minLength: 2,
                      message: "City must contain at least 2 characters.",
                    },
                  ],
                  maxLength: 35,
                  tooltip: `Enter the city of the intended place of employment.`,
                },
                {
                  code: "F.8",
                  machine_name: "_section_f_f8_work_state_id",
                  disableWhenField: {
                    when: "_section_f_f12_f13_f14_prevailing_wage_question",
                    is: "f13_is_oes_prevailing_wage",
                  },
                  disabled: true,
                  disabledOnEdit: true,
                  widget: "select",
                  label: "State/District/Territory",
                  state: true,
                  selection: data.state,
                  type: "state",
                  parentComponent: "fieldArrayGenerator",
                  required: true,
                  tooltip: `Enter the State/district/territory of intended employment.`,
                },
                {
                  code: "F.7",
                  machine_name: "_section_f_f7_work_county_id",
                  skipFirstReset: true,
                  widget: "countyselect",
                  label: "County",
                  disabledOnEdit: true,
                  validate: [
                    {
                      isNotRequired: "_section_f_f8_work_state_id",
                      needsFieldValues: true,
                      extraData: {
                        valueOf: "- Select -",
                      },
                    },
                    {
                      required_county: "_section_f_f8_work_state_id",
                      message: "",
                      needsFieldValues: true,
                    },
                  ],
                  required: true,
                  tooltip: `Enter the county of the intended place of employment. If there is no county designation or it is not known, please enter “N/A”. Note: In the absence of a county, enter the appropriate parish or borough in this field. Do not enter a country in this field.`,
                  disableWhenField: [
                    {
                      when: "_section_f_f8_work_state_id",
                      is: [
                        "",
                        null,
                        undefined,
                        "- Select -",
                        "AMERICAN SAMOA",
                        "FEDERATED STATES OF MICRONESIA",
                        "MARSHALL ISLANDS",
                        "PALAU",
                      ],
                    },
                    {
                      when: "OES_area_based",
                      is: "County/Township",
                    },
                    {
                      when: "OES_area_based",
                      is: "BLS Area",
                    },
                  ],
                  disabled: false,
                },
                {
                  code: "F.9",
                  machine_name: "_section_f_f9_work_zip",
                  widget: "text",
                  label: "Postal Code",
                  required: true,
                  validate: [
                    // "required",
                    {
                      postalCountry: "c8_emp_country_id",
                      needsFieldValues: true,
                      extraData: {
                        valueOf: "c8_emp_country_id",
                      },
                    },
                  ],
                  maxLength: 10,
                  tooltip: `Enter the postal (zip) code of the intended place of employment.`,
                },
              ],
            },
            {
              fields: [
                {
                  machine_name: "_state_minimum_wage",
                  widget: "minimum_wage",
                  minimum_wage: {
                    isState: true,
                    label: "State Minimum Wage",
                    state: "_section_f_f8_work_state_id",
                    state_code: "F.8",
                    per: "_section_f_f10a_nonimmigrant_wage_per",
                    per_code: "F.10a",
                  },
                  hidden: true,
                },
                {
                  machine_name: "_federal_minimum_wage",
                  widget: "minimum_wage",
                  minimum_wage: {
                    isState: false, // federal
                    label: "Federal Minimum Wage",
                    state: "_section_f_f8_work_state_id",
                    state_code: "F.8",
                    per: "_section_f_f10a_nonimmigrant_wage_per",
                    per_code: "F.10a",
                  },
                  hidden: true,
                },
                {
                  machine_name: "_",
                  widget: "minimum_wage_display",
                  minimum_wage_display: {
                    based_on: ["F.8", "F.10a"],
                    state_field: "_section_f_f8_work_state_id",
                    state: "_state_minimum_wage",
                    state_per: "_section_f_f10a_nonimmigrant_wage_per",
                    federal: "_federal_minimum_wage",
                    federal_per: "_section_f_f10a_nonimmigrant_wage_per",
                  },
                },
                {
                  isGroup: {
                    code: "F.10",
                    label: "Wage Rate Paid to Nonimmigrant Workers",
                    showIndividualFieldError: true,
                    tooltip:
                      "Enter the wage to be paid to the nonimmigrant worker(s). If the wage offer is expressed as a range, enter the bottom of the wage range to be paid. Enter the top of the wage range to be paid to the nonimmigrant worker(s) in the section indicating “To” (required only for employers paying a wage range).",
                    fields: [
                      {
                        machine_name: "_section_f_f10_nonimmigrant_wage_from",
                        widget: "wage",
                        label: "From",
                        required: true,
                        maxLength: 10,
                        placeholder: "$nnnnnnnnnn.nn",
                        validate: [
                          {
                            fieldComparison:
                              "_section_f_f10_nonimmigrant_wage_from",
                            message:
                              "The wage rate is less than the State Minimum Wage",
                            needsFieldValues: true,
                            extraData: {
                              operator: ">=",
                              valueOf: "_state_minimum_wage",
                            },
                          },
                          {
                            fieldComparison:
                              "_section_f_f10_nonimmigrant_wage_from",
                            message:
                              "The wage rate is less than the Federal Minimum Wage",
                            needsFieldValues: true,
                            extraData: {
                              operator: ">=",
                              valueOf: "_federal_minimum_wage",
                            },
                          },
                          {
                            prevailingWageCheck:
                              "_section_f_f10_nonimmigrant_wage_from",
                            message:
                              "The value entered is lower than the Prevailing Wage.",
                            needsFieldValues: true,
                            extraData: {
                              prevailing_wage: "_section_f_f11_prevailing_wage",
                              prevailing_wage_per:
                                "_section_f_f11a_prevailing_wage_per",
                              wage_per: "_section_f_f10a_nonimmigrant_wage_per",
                            },
                          },
                        ],
                        warnings: [
                          {
                            text: "You have entered a rate of pay equal to or greater than $350,000. Please make sure you have entered the correct wage rate before submitting this application for processing.",
                            isVisible: {
                              when: "_section_f_f10_nonimmigrant_wage_from",
                              is: "350000",
                              operator: ">=",
                            },
                          },
                          {
                            text: "Offered wage is 200% or more than the Prevailing Wage",
                            isVisible: {
                              when: "_section_f_f10_nonimmigrant_wage_from",
                              is: [
                                "_section_f_f11_prevailing_wage",
                                "_section_f_f10a_nonimmigrant_wage_per",
                                "_section_f_f11a_prevailing_wage_per",
                              ],
                              operator: "prevailingWage200PercentCheck",
                            },
                          },
                        ],
                      },
                      {
                        machine_name: "_section_f_f10_nonimmigrant_wage_to",
                        widget: "wage",
                        label: "To",
                        maxLength: 10,
                        placeholder: "$nnnnnnnnnn.nn",
                        validate: [
                          {
                            fieldComparison:
                              "_section_f_f10_nonimmigrant_wage_to",
                            message:
                              'The "To" must be higher than the "From" wage rate',
                            needsFieldValues: true,
                            extraData: {
                              operator: ">",
                              valueOf: "_section_f_f10_nonimmigrant_wage_from",
                            },
                          },
                          {
                            fieldComparison:
                              "_section_f_f10_nonimmigrant_wage_to",
                            message:
                              "The wage rate is less than the State Minimum Wage",
                            needsFieldValues: true,
                            extraData: {
                              operator: ">=",
                              valueOf: "_state_minimum_wage",
                            },
                          },
                          {
                            fieldComparison:
                              "_section_f_f10_nonimmigrant_wage_to",
                            message:
                              "The wage rate is less than the Federal Minimum Wage",
                            needsFieldValues: true,
                            extraData: {
                              operator: ">=",
                              valueOf: "_federal_minimum_wage",
                            },
                          },
                          {
                            prevailingWageCheck:
                              "_section_f_f10_nonimmigrant_wage_to",
                            message:
                              "The value entered is lower than the Prevailing Wage.",
                            needsFieldValues: true,
                            extraData: {
                              prevailing_wage: "_section_f_f11_prevailing_wage",
                              prevailing_wage_per:
                                "_section_f_f11a_prevailing_wage_per",
                              wage_per: "_section_f_f10a_nonimmigrant_wage_per",
                            },
                          },
                        ],
                        warnings: [
                          {
                            text: "You have entered a rate of pay equal to or greater than $350,000. Please make sure you have entered the correct wage rate before submitting this application for processing.",
                            isVisible: {
                              when: "_section_f_f10_nonimmigrant_wage_to",
                              is: "350000",
                              operator: ">=",
                            },
                          },
                          {
                            text: "Offered wage is 200% or more than the Prevailing Wage",
                            isVisible: {
                              when: "_section_f_f10_nonimmigrant_wage_to",
                              is: [
                                "_section_f_f11_prevailing_wage",
                                "_section_f_f10a_nonimmigrant_wage_per",
                                "_section_f_f11a_prevailing_wage_per",
                              ],
                              operator: "prevailingWage200PercentCheck",
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  isGroup: {
                    code: "F.10a",
                    machine_name: "_section_f_f10a_nonimmigrant_wage_per",
                    label: "Per",
                    required: true,
                    tooltip: `Indicate whether the rate of pay unit is per hour, week, bi-week (every two weeks), month, or year.`,
                    fields: [
                      {
                        widget: "radio",
                        choice: "Hour",
                        value: "Hour",
                        disableWhenField: {
                          when: "_section_f_f11a_prevailing_wage_per",
                          is: ["Hour", "Week", "Bi-Weekly", "Month", "Year"],
                        },
                        disabled: true,
                        validate: [
                          {
                            fieldNotEqualToWhenOtherFieldIs:
                              "_section_f_f10a_nonimmigrant_wage_per",
                            needsFieldValues: true,
                            message:
                              "The wage rate must be entered as an hourly wage if the foreign worker will be employed part-time",
                            extraData: {
                              notEqual: ["Year", "Month", "Week", "Bi-Weekly"],
                              when: "b4_is_full_time",
                              is: "NO",
                            },
                          },
                        ],
                      },
                      {
                        widget: "radio",
                        choice: "Week",
                        value: "Week",
                        disableWhenField: {
                          when: "_section_f_f11a_prevailing_wage_per",
                          is: ["Hour", "Week", "Bi-Weekly", "Month", "Year"],
                        },
                        disabled: true,
                      },
                      {
                        widget: "radio",
                        choice: "Bi-Weekly",
                        value: "Bi-Weekly",
                        disableWhenField: {
                          when: "_section_f_f11a_prevailing_wage_per",
                          is: ["Hour", "Week", "Bi-Weekly", "Month", "Year"],
                        },
                        disabled: true,
                      },
                      {
                        widget: "radio",
                        choice: "Month",
                        value: "Month",
                        disableWhenField: {
                          when: "_section_f_f11a_prevailing_wage_per",
                          is: ["Hour", "Week", "Bi-Weekly", "Month", "Year"],
                        },
                        disabled: true,
                      },
                      {
                        widget: "radio",
                        choice: "Year",
                        value: "Year",
                        disableWhenField: {
                          when: "_section_f_f11a_prevailing_wage_per",
                          is: ["Hour", "Week", "Bi-Weekly", "Month", "Year"],
                        },
                        disabled: true,
                      },
                    ],
                  },
                },
                {
                  machine_name: "_federal_minimum_wage_f11",
                  widget: "minimum_wage",
                  minimum_wage: {
                    isState: false, // federal
                    label: "Federal Minimum Wage",
                    state: "_section_f_f8_work_state_id",
                    state_code: "F.8",
                    per: "_section_f_f11a_prevailing_wage_per",
                    per_code: "F.11a",
                  },
                  hidden: true,
                },
                {
                  machine_name: "_",
                  widget: "minimum_wage_display",
                  minimum_wage_display: {
                    based_on: ["F.8", "F.11a"],
                    state_field: "_section_f_f8_work_state_id",
                    federal: "_federal_minimum_wage_f11",
                    federal_per: "_section_f_f11a_prevailing_wage_per",
                  },
                },
                {
                  code: "F.11",
                  machine_name: "_section_f_f11_prevailing_wage",
                  widget: "wage",
                  disableWhenField: [
                    {
                      when: "_section_f_f12_f13_f14_prevailing_wage_question",
                      is: ["f12_is_dol_prevailing_wage", "f13_is_oes_prevailing_wage"],
                    }
                  ],
                  disabled: true,
                  required: true,
                  label: "Prevailing Wage Rate",
                  tooltip: `Enter the prevailing wage for the job opportunity.`,
                  maxLength: 10,
                  placeholder: "$nnnnnnnnnn.nn",
                  validate: [
                    {
                      fieldComparison: "_section_f_f11_prevailing_wage",
                      message:
                        "The value entered is lower than the Federal Minimum Wage",
                      needsFieldValues: true,
                      extraData: {
                        operator: ">=",
                        valueOf: "_federal_minimum_wage_f11", // we will need to change this whenever the Federal Minimum Wage goes up...
                      },
                    },
                  ],
                  warning: {
                    text: "You have entered a prevailing wage for this job that is equal to or greater than $350,000. Please make sure you have entered the correct wage rate before submitting this application for processing.",
                    isVisible: {
                      when: "_section_f_f11_prevailing_wage",
                      is: "350000",
                      operator: ">=",
                    },
                  },
                },
                {
                  isGroup: {
                    code: "F.11a",
                    machine_name: "_section_f_f11a_prevailing_wage_per",
                    widget: "radio",
                    label: "Per",
                    required: true,
                    disableWhenField: [
                      {
                        when: "_section_f_f12_f13_f14_prevailing_wage_question",
                        is: ["f12_is_dol_prevailing_wage", "f13_is_oes_prevailing_wage"],
                      }
                    ],
                    disabled: true,
                    tooltip: `Indicate whether prevailing wage unit is per hour, week, bi-week (every two weeks), month, or year.`,
                    fields: [
                      {
                        widget: "radio",
                        choice: "Hour",
                        value: "Hour",
                        disableWhenField: [
                          {
                            when: "_section_f_f12_f13_f14_prevailing_wage_question",
                            is: ["f12_is_dol_prevailing_wage", "f13_is_oes_prevailing_wage"],
                          }
                        ],
                        disabled: true,
                        validate: [
                          {
                            fieldNotEqualToWhenOtherFieldIs:
                              "_section_f_f11a_prevailing_wage_per",
                            needsFieldValues: true,
                            message:
                              "The prevailing wage must be entered as an hourly wage if the foreign worker will be employed part-time.",
                            extraData: {
                              notEqual: ["Year", "Month", "Week", "Bi-Weekly"],
                              when: "b4_is_full_time",
                              is: "NO",
                            },
                          },
                        ],
                      },
                      {
                        widget: "radio",
                        choice: "Week",
                        value: "Week",
                        disableWhenField: [
                          {
                            when: "_section_f_f12_f13_f14_prevailing_wage_question",
                              is: ["f12_is_dol_prevailing_wage", "f13_is_oes_prevailing_wage"],
                          }
                        ],
                        disabled: true,
                      },
                      {
                        widget: "radio",
                        choice: "Bi-Weekly",
                        value: "Bi-Weekly",
                        disableWhenField: [
                          {
                            when: "_section_f_f12_f13_f14_prevailing_wage_question",
                              is: ["f12_is_dol_prevailing_wage", "f13_is_oes_prevailing_wage"],
                          }
                        ],
                        disabled: true,
                      },
                      {
                        widget: "radio",
                        choice: "Month",
                        value: "Month",
                        disableWhenField: [
                          {
                            when: "_section_f_f12_f13_f14_prevailing_wage_question",
                              is: ["f12_is_dol_prevailing_wage", "f13_is_oes_prevailing_wage"],
                          }
                        ],
                        disabled: true,
                      },
                      {
                        widget: "radio",
                        choice: "Year",
                        value: "Year",
                        disableWhenField: [
                          {
                            when: "_section_f_f12_f13_f14_prevailing_wage_question",
                              is: ["f12_is_dol_prevailing_wage", "f13_is_oes_prevailing_wage"],
                          }
                        ],
                        disabled: true,
                      },
                    ],
                  },
                },
                {
                  widget: "alert",
                  description:
                    "If you navigate away from this page without clicking the 'Add Place of Employment' button, your changes will be lost. Your entry will be displayed in the table below.",
                  type: "warning",
                },
              ],
            },
          ],
        },
      },
    },
  ],
};
